import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AdminStudentPlatformHeaderComponent } from '../admin-student-platform-header/admin-student-platform-header.component';
import { AdminStudentPlatformService } from '@edtech-ui/core/services/admin-student-platform.service';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';
interface Payment {
  user_id: string;
  user_name: string;
  transaction_id: string | null;
  amount: number;
  payment_date: string | null;
  status: string;
  order_id: string;
}
interface AdminDashboardStats {
  total_payments_amount: number;
  failed_payments: number;
  total_transactions: number;
}
@Component({
  selector: 'app-admin-student-platform-payments-invoices',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminStudentPlatformHeaderComponent,HasPermissionDirective],
  templateUrl: './admin-student-platform-payments-invoices.component.html',
  styleUrl: './admin-student-platform-payments-invoices.component.scss'
})
export class AdminStudentPlatformPaymentsInvoicesComponent {

  payments: Payment[] = [];
  searchTerm = '';
  paymentStatus = 'completed';
  currentPage = 1;
  pageSize = 10;
  totalRecords = 0;
  totalPages = 0;
  loading = false;
  dashboardStats!: AdminDashboardStats;
  PermissionForStudents= PermissionForStudents;


  constructor(
    private adminService: AdminStudentPlatformService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.fetchPayments();
    this.loadDashboardStats();

  }
  loadDashboardStats() {
    this.adminService.getDashboardStats().subscribe({
      next: (data: any) => {
        const stats = data?.Data || data;
        this.dashboardStats = {
          total_payments_amount: stats?.total_payments_amount || 0,
          failed_payments: stats?.failed_payments || 0,
          total_transactions: stats?.total_transactions || 0
        };
      },
      error: () => {
        this.toastr.error('Failed to load stats', 'Error');
        this.dashboardStats = {
          total_payments_amount: 0,
          failed_payments: 0,
          total_transactions: 0
        };
      }
    }); 
  }

  fetchPayments() {
    this.loading = true;

    this.adminService.getPayments(
      this.currentPage,
      this.pageSize,
      this.searchTerm,
      this.paymentStatus
    ).subscribe({
      next: (res) => {
        this.payments = res.payments;
        this.totalRecords = res.total;
        this.totalPages = res.total_pages;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }


  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.fetchPayments();
    }
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  getEndIndex(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalRecords);
  }

  onSearch() {
    this.currentPage = 1;
    this.fetchPayments();
  }

  onStatusChange() {
    this.currentPage = 1;
    this.fetchPayments();
  }

  get totalSuccess() {
    return this.payments
      .filter(p => p.status?.toLowerCase() === 'completed')
      .reduce((sum, p) => sum + p.amount, 0);
  }

  get totalFailed() {
    return this.payments
      .filter(p => p.status?.toLowerCase() === 'failed')
      .reduce((sum, p) => sum + p.amount, 0);
  }

  get totalTransactions() {
    return this.totalRecords;
  }

  downloadInvoice(orderId: string) {
    if (!orderId) {
      this.toastr.error('Invoice not available', 'Error');
      return;
    }

    this.adminService.downloadInvoice(orderId).subscribe({
      next: (blob: Blob) => {
        const reader = new FileReader();

        reader.onload = () => {
          try {
            const result = reader.result as string;
            const jsonResponse = JSON.parse(result);

            if (jsonResponse?.Success === false) {
              const errorMessage = jsonResponse?.Message || 'Order not found or not completed';
              this.toastr.error(errorMessage, 'Error');
              return;
            }
          } catch (e) {
          }

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `invoice-${orderId}.pdf`;
          a.click();
          window.URL.revokeObjectURL(url);
          this.toastr.success('Invoice downloaded successfully', 'Success');
        };

        reader.readAsText(blob);
      },
      error: (err) => {
        const errorMessage = err?.error?.Message || err?.message || 'Failed to download invoice';
        this.toastr.error(errorMessage, 'Error');
      }
    });
  }

}
